export enum PricingLayouts {
  ONE = "Pricing 01",
  TWO = "Pricing 02",
  THREE = "Pricing 03",
  FOUR = "Pricing 04",
  FIVE = "Pricing 05",
  SIX = "Pricing 06"
}
